import { Controller } from "@hotwired/stimulus";
import Choices from "choices.js";

// Connects to data-controller="select2"
export default class extends Controller {
  static classes = ["invalid"];
  static targets = ["element"];

  instance;

  wrap(el, wrapper) {
    if (el && el.parentNode) {
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    }
  }

  connect() {
    if (
      this.element.type === "select-one" ||
      ["INPUT", "SELECT"].includes(this.element.nodeName)
    ) {
      this.element.setAttribute("data-choices-target", "element");

      const wrapper = document.createElement("div");

      this.element.parentElement.appendChild(wrapper);
      this.wrap(this.element, wrapper);
      wrapper.setAttribute("data-controller", "choices");
      this.element.removeAttribute("data-controller");
      return;
    }

    const options = JSON.parse(this.data.get("config")) || {};

    this.instance = new Choices(
      this.elementTarget,
      Object.assign(
        {
          classNames: {
            ontainerOuter: "choices",
            containerInner:
              "choices__inner border dark:border-zinc-700 rounded-full !p-1.5 !text-sm !mt-1".split(
                " ",
              ),
            input: "choices__input !p-1.5 form-input".split(" "),
            inputCloned:
              "choices__input--cloned dark:bg-zinc-800 !p-1.5 !border-none focus:!border-none focus:!ring-none".split(
                " ",
              ),
            list: "choices__list",
            listItems: "choices__list--multiple",
            listSingle: "choices__list--single",
            listDropdown: "choices__list--dropdown",
            item: "choices__item",
            itemSelectable: "choices__item--selectable",
            itemDisabled: "choices__item--disabled",
            itemOption: "choices__item--choice",
            group: "choices__group",
            groupHeading: "choices__heading",
            button: "choices__button",
            activeState: "is-active",
            focusState: "is-focused",
            openState: "is-open",
            disabledState: "is-disabled",
            highlightedState: "is-highlighted",
            selectedState: "is-selected is-highlighted".split(" "),
            flippedState: "is-flipped",
          },
        },
        options,
      ),
    );
  }

  update({ detail }) {
    this.instance.setChoiceByValue(detail.toString());
  }

  disconnect() {
    this.instance?.destroy();
  }
}
